$(function () {
  //   $(".datepicker").datepicker({
  //     showOtherMonths: true,
  //     selectOtherMonths: true,
  //     dateFormat: "dd.mm.yy",
  //   });

  $.datepicker.setDefaults($.datepicker.regional.cs);

  var dateFormat = "dd.mm.yy";

  function getDate(dateString) {
    var date;
    try {
      date = $.datepicker.parseDate(dateFormat, dateString);
    } catch (error) {
      date = null;
    }

    return date;
  }

  $(".js-daterange").each(function () {
    var daterange = $(this);
    var from = daterange.find(".js-daterange-from");
    var to = daterange.find(".js-daterange-to");

    function beforeShowDay(date) {
      var fromDate = new Date(getDate(from.val()));
      var toDate = new Date(getDate(to.val()));

      if (
        date.getTime() == fromDate.getTime() ||
        date.getTime() == toDate.getTime()
      )
        return [true, "ui-selected", ""];

      if (from.val() && to.val() && date > fromDate && date < toDate)
        return [true, "ui-in-range", ""];

      return [true, "", ""];
    }

    from.datepicker({
      showOtherMonths: true,
      selectOtherMonths: true,
      dateFormat: dateFormat,
      firstDay: 1,
      minDate: "+0d",
      onSelect: function (date) {
        var selectedDate = getDate(date);
        var nextDay = new Date(selectedDate);
        nextDay.setDate(nextDay.getDate() + 1);
        to.datepicker("option", "minDate", nextDay);
      },
      beforeShowDay: beforeShowDay,
    });

    to.datepicker({
      showOtherMonths: true,
      selectOtherMonths: true,
      dateFormat: dateFormat,
      firstDay: 1,
      onSelect: function (date) {
        var selectedDate = getDate(date);
        var prevDay = new Date(selectedDate);
        prevDay.setDate(prevDay.getDate() - 1);
        from.datepicker("option", "maxDate", prevDay);
      },
      beforeShowDay: beforeShowDay,
    });
  });
});
